export default "__VITE_ASSET__DYKTTERS__"